import React, { useState, useEffect } from 'react'
import CourseHeader from '../../Components/CourseHeader'
import { Helmet } from 'react-helmet-async'
import { Row, Col, Card, Form, Input, Space } from 'antd'
import ImageUploader from '../../Components/ImageUploader/ImageUploader'
import useGetApi from '../../services/useGetApi'
import usePut from '../../services/usePut'
import useCustomSnackbar from '../../helper/useCustomSnackbar'
import { changePasswordValidation } from '../../validations/authValidation'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'

const { TextArea } = Input;

const MyProfile = () => {
	const [basicForm] = Form.useForm();
	const [passwordForm] = Form.useForm();
	const [thumbnailURL, setThumbnailURL] = useState(null);
	const [socialLinks, setSocialLinks] = useState({
		twitter: "",
		facebook: "",
		linkedin: "",
	});
	const [isLoading, courseError, userData, getData] = useGetApi(
		"users/get",
		[],
		true
	);
	const { handleSubmit, control, formState: { errors } } = useForm({
		resolver: yupResolver(changePasswordValidation),
		mode: "onChange",
	});
	const [putLoading, errorMsg, putData] = usePut();
	const showSnackbar = useCustomSnackbar()

	useEffect(() => {
		getData("users/get");
	}, []);

	const handleImageUpload = (filePath) => {
		setThumbnailURL(filePath);
	};


	useEffect(() => {
		if (userData) {
			let socialLinks = typeof userData?.socialLinks === 'string'
				? JSON.parse(userData.socialLinks)
				: userData.socialLinks;

			setSocialLinks(socialLinks)

			basicForm.setFieldsValue({
				firstName: userData?.firstName,
				lastName: userData?.lastName,
				email: userData?.email,
				skills: userData?.skills,
				title: userData?.title,
				biography: userData?.biography,
				twitterLink: socialLinks?.twitter,
				facebookLink: socialLinks?.facebook,
				linkedinLink: socialLinks?.linkedin,
				biography: userData?.biography
			})

		}
	}, [userData])


	//api call for Basic details 

	const basicDetailsOnFinish = async (values) => {

		const dataToSave = {
			...userData,
			...values,
			socialLinks: JSON.stringify(socialLinks),
			image: thumbnailURL ? thumbnailURL : userData?.image
		}

		const response = await putData(`users/${userData.id}`, dataToSave, true);
		console.log(values, 'user')
	}


	// api call for password change

	const onFinishPasswordChange = async (values) => {

		if (values.confirmNewPassword !== values.newPassword) {
			showSnackbar('error', 'New password and Confirm password must match')
			return
		}

		const dataToSave = {
			...userData,
			password: values.newPassword

		}

		const response = await putData(`users/${userData.id}`, dataToSave, true);

		if(response){
			passwordForm.resetFields()
		}
	}



	return (
		<div className='mt-50'>
			<Helmet>
				<title>Profile| LMS-admin</title>
			</Helmet>

			<CourseHeader header={"My Profile"} />

			<Row gutter={20} className='mt-50'>
				<Col span={12}>
					<Card title="Basic Info" variant="borderless"  >
						<Form
							form={basicForm}
							layout="vertical"
							onFinish={basicDetailsOnFinish}
							// onFinishFailed={onFinishFailed}
							autoComplete="off"
						>
							<Form.Item
								label="First name"
								name="firstName"
							>
								<Input
									placeholder="Enter first name"
								/>
							</Form.Item>

							<Form.Item
								label="Last name"
								name="lastName"

							>
								<Input
									placeholder="Enter last name"
								/>
							</Form.Item>

							<Form.Item
								label="Email"
								name="email"
							>
								<Input
									placeholder="Enter email"
								/>
							</Form.Item>

							<Form.Item
								label="Facebook Link"
								name="facebookLink"
							>
								<Input
									placeholder="Enter facebook link"
									onChange={(e) => (
										setSocialLinks((prev) => (
											{
												...prev,
												facebook: e.target.value
											}
										))
									)}
								/>
							</Form.Item>

							<Form.Item
								label="Twitter Link"
								name="twitterLink"
							>
								<Input
									placeholder="Enter Twitter link"
									onChange={(e) => (
										setSocialLinks((prev) => (
											{
												...prev,
												twitter: e.target.value
											}
										))
									)}
								/>
							</Form.Item>

							<Form.Item
								label="Linkedin Link"
								name="linkedinLink"
							>
								<Input
									placeholder="Enter Linkedin link"
									onChange={(e) => (
										setSocialLinks((prev) => (
											{
												...prev,
												linkedin: e.target.value
											}
										))
									)}
								/>
							</Form.Item>

							<Form.Item
								label="Skills"
								name="skills"
							>
								<Input
									placeholder="Enter your skills"
								/>
							</Form.Item>

							<Form.Item
								label="A short title about yourself"
								name="title"
							>
								<TextArea
									rows={4}
									placeholder="A short title about yourself"
								/>
							</Form.Item>

							<Form.Item
								label="Biography"
								name="biography"
							>
								<TextArea
									rows={4}
									placeholder="A short biography about yourself"
								/>
							</Form.Item>

							<Form.Item
								label="Photo (The image size should be any square image)"
								name="image"
							>
								<ImageUploader
									subdir="userprofile"
									onImageUpload={handleImageUpload}
									imageUrl={userData?.image}
								/>
							</Form.Item>

							<Form.Item>
								<Space>
									<Row className="submit_btn_div">
										<button
											className="popup_submit_btn"
											htmlType="submit"
										// loading={isPostLoading} 
										>
											Submit
										</button>
									</Row>
								</Space>
							</Form.Item>
						</Form>
					</Card>
				</Col>

				<Col span={10}>
					<Card>
						{/* <Form
							form={passwordForm}
							layout="vertical"
							onFinish={handleSubmit(onFinishPasswordChange)}
							// onFinish={onFinishPasswordChange}
							// onFinishFailed={onFinishFailed}
							autoComplete="off"
						>

							<Form.Item
								label={
									<span>Current Password <span style={{ color: 'red' }}>*</span>
									</span>
								}
								validateStatus={errors.currentPassword ? "error" : ""} help={errors.currentPassword?.message}>
								<Controller
									name="currentPassword"
									control={control}
									render={({ field }) => <Input.Password {...field} className="input_field" placeholder="Current password" />}
								/>
							</Form.Item>
							<Form.Item
								label={
									<span>New Password <span style={{ color: 'red' }}>*</span>
									</span>
								}
								validateStatus={errors.newPassword ? "error" : ""}
								help={errors.newPassword?.message}>
								<Controller
									name="newPassword"
									control={control}
									render={({ field }) => <Input.Password {...field} className="input_field" placeholder="Password" />}
								/>
							</Form.Item>

							<Form.Item
								label={
									<span>Confirm New Password<span style={{ color: 'red' }}>*</span>
									</span>
								}

								// name="confirmNewPassword"
								validateStatus={errors.confirmNewPassword ? "error" : ""}
								help={errors.confirmNewPassword?.message}
							>
								<Controller
									name='confirmNewPassword'
									control={control}
									render={({ field }) => <Input {...field} className='input_field'
										placeholder='Confirm new password' />}
								/>
							</Form.Item>

							<Form.Item>
								<Space>
									<Row className="submit_btn_div">
										<button
											className="popup_submit_btn"
											htmlType="submit"
										>
											Submit
										</button>
									</Row>
								</Space>
							</Form.Item>
						</Form> */}
						<Form
						  form={passwordForm}
							layout="vertical"
							onFinish={onFinishPasswordChange}
							// onFinish={onFinishPasswordChange}
							// onFinishFailed={onFinishFailed}
							autoComplete="off"
						>
							{/* <Form.Item
								label="Current Password"
								name="currentPassword"
                                rules={[{
									required: true,
									message: 'Please enter your current password!',
								}]}
							>
								<Input
									placeholder="Enter current password"
								/>
							</Form.Item> */}

							<Form.Item
								label="New Password"
								name="newPassword"
                                rules={[{
									required: true,
									message: 'Please enter your new password!',
								}]}
							>
								<Input
									placeholder="Enter new password"
								/>
							</Form.Item>

							<Form.Item
								label="Confirm New Password"
								name="confirmNewPassword"
                                rules={[{
									required: true,
									message: 'Please confirm your new password!',
								}]}
								>
								<Input
									placeholder="Confirm new password"
								/>
							</Form.Item>

							<Form.Item>
								<Space>
									<Row className="submit_btn_div">
										<button
											className="popup_submit_btn"
											htmlType="submit"
										>
											Submit
										</button>
									</Row>
								</Space>
							</Form.Item>
						</Form>
					</Card>
				</Col>
			</Row>

		</div>
	)
}

export default MyProfile
